import React, { useCallback, useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import Button from 'shared/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignature } from '@fortawesome/pro-solid-svg-icons';
import PropTypes from 'prop-types';
import { createPortal } from 'react-dom';

export default function OnMarketDisclaimer({ address, disclaimerText, name, signerId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [hasSignedDisclaimer, setHasSignedDisclaimer] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const showModal = () => setIsOpen(true);
  const hideModal = () => setIsOpen(false);

  function cancelSigning() {
    hideModal();
    setAgreedToTerms(false);
    setHasSignedDisclaimer(false);
  }

  function signDisclaimer() {
    setHasSignedDisclaimer(true);
    hideModal();
    document.querySelector('.submitLink').click();
  }

  useEffect(() => {
    document.addEventListener('show_disclaimer', showModal);

    return () => document.removeEventListener('show_disclaimer', showModal);
  }, []);

  const setTextareaHeight = useCallback((node) => {
    if (node !== null) {
      node.style.height = `${node.scrollHeight + 2}px`;
    }
  }, []);

  function dateTimeFormatted(options) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(now);
  }

  function formattedDate() {
    const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
    return dateTimeFormatted(options);
  }

  function formattedTime() {
    const options = { hour: 'numeric', minute: '2-digit', hour12: true };
    return dateTimeFormatted(options);
  }

  return (
    <React.Fragment>
      {createPortal(
        <React.Fragment>
          {hasSignedDisclaimer ? (
            <React.Fragment>
              <input
                name="property[signed_on_market_disclaimers_attributes][0][disclaimer_text]"
                type="hidden"
                value={disclaimerText}
              />
              <input
                name="property[signed_on_market_disclaimers_attributes][0][signer_id]"
                type="hidden"
                value={signerId}
              />
            </React.Fragment>
          ) : null
          }
        </React.Fragment>,
        document.getElementById('on-market-disclaimer')
      )}

      <Modal dialogClassName="modal-sm" show={isOpen} onHide={hideModal}>
        <Modal.Body className="p-5">
          <div className="text-center">
            <FontAwesomeIcon className="icon-gradient" icon={faSignature} size="2x"/>
          </div>

          <h3 className="text-center my-4">Sign Disclaimer To Go On Market</h3>

          <textarea className="form-control form-group" disabled ref={setTextareaHeight} value={disclaimerText}/>

          <div className="form-group">
            <label>Address</label>
            <input className="form-control" disabled type="text" value={address}/>
          </div>

          <div className="form-group">
            <label>Name</label>
            <input className="form-control" disabled type="text" value={name}/>
          </div>

          <div className="d-flex justify-content-between flex-wrap">
            <label className="d-flex align-items-center mb-0">
              <input
                checked={agreedToTerms}
                className="mt-0 mr-2"
                type="checkbox"
                onChange={() => setAgreedToTerms(!agreedToTerms)}
              />
              <span style={{ fontWeight: 400 }}>I have read and agree to the Terms</span>
            </label>

            <span className="text-muted">Signed {formattedDate()} at {formattedTime()}</span>
          </div>

          <div className="d-flex justify-content-center mt-5">
            <Button.Accent
              className="mr-3"
              disabled={hasSignedDisclaimer}
              outlined
              onClick={cancelSigning}
            >
              Cancel
            </Button.Accent>
            <Button.Primary disabled={!agreedToTerms || hasSignedDisclaimer} onClick={signDisclaimer}>
              Sign Disclaimer
            </Button.Primary>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
}

export const onMarketDisclaimerProps = {
  address: PropTypes.string,
  disclaimerText: PropTypes.string,
  name: PropTypes.string,
  signerId: PropTypes.number
};

OnMarketDisclaimer.propTypes = onMarketDisclaimerProps;
